import Vue from "vue";
import CollectFileInfo from './CollectFileInfo/CollectFileInfo.vue'; 
import CollectionItem from './collectionItem/CollectionItem.vue'; 
import CollectionListItem from './CollectionListItem/CollectionListItem.vue'; 
import ColorSwatch from './ColorSwatch/ColorSwatch.vue'; 
import DesktopEmpty from './DesktopEmpty/DesktopEmpty.vue'; 
import DesktopFileItem from './DesktopFileItem/DesktopFileItem.vue'; 
import DetailField from './DetailField/DetailField.vue'; 
import DownloadFilePreview from './DownloadFilePreview/DownloadFilePreview.vue'; 
import DownloadFolderPreview from './DownloadFolderPreview/DownloadFolderPreview.vue'; 
import DownloadItemsPreview from './DownloadItemsPreview/DownloadItemsPreview.vue'; 
import Face from './Face/Face.vue'; 
import FileDrop from './FileDrop/FileDrop.vue'; 
import FileItem from './FileItem/FileItem.vue'; 
import FileOverlayItem from './FileOverlayItem/FileOverlayItem.vue'; 
import FileUploadPreviewItem from './FileUploadPreviewItem/FileUploadPreviewItem.vue'; 
import FolderUploadPreviewItem from './FolderUploadPreviewItem/FolderUploadPreviewItem.vue'; 
import ImagePreloader from './ImagePreloader/ImagePreloader.vue'; 
import Loader from './Loader/Loader.vue'; 
import LoadingScreen from './LoadingScreen/LoadingScreen.vue'; 
import MenuItem from './MenuItem/MenuItem.vue'; 
import MobileProgressbar from './MobileProgressbar/MobileProgressbar.vue'; 
import Remaining from './Remaining/Remaining.vue'; 
import SearchField from './SearchField/SearchField.vue'; 
import SearchFilter from './SearchFilter/SearchFilter.vue'; 
import SearchTab from './searchTab/SearchTab.vue'; 
import SnackbarItem from './SnackbarItem/SnackbarItem.vue'; 
import SortOption from './SortOption/SortOption.vue'; 
import SvgIcon from './SvgIcon/SvgIcon.vue'; 
import Tag from './Tag/Tag.vue'; 
import ToolTip from './ToolTip/ToolTip.vue'; 
import TooltipBtn from './TooltipBtn/TooltipBtn.vue'; 
import TopOption from './TopOption/TopOption.vue'; 
import TreeTitle from './TreeTitle/TreeTitle.vue'; 
import UserMenuItem from './UserMenuItem/UserMenuItem.vue'; 
import Vaccordeon from './VAccordeon/Vaccordeon.vue'; 
import Vbutton from './VButton/Vbutton.vue'; 
import Vcheck from './VCheck/Vcheck.vue'; 
import Vcolor from './VColor/Vcolor.vue'; 
import Vdropdown from './VDropdown/Vdropdown.vue'; 
import ViewOption from './ViewOption/ViewOption.vue'; 
import Vinput from './VInput/Vinput.vue'; 
import Vlink from './VLink/Vlink.vue'; 
import Vslider from './VSlider/Vslider.vue'; 
import Vswitch from './VSwitch/Vswitch.vue'; 
import VTextEditor from './VTextEditor/VTextEditor.vue'; 


const importAllVue = () => {
	Vue.component("collect-file-info", CollectFileInfo); 
	Vue.component("collection-item", CollectionItem); 
	Vue.component("collection-list-item", CollectionListItem); 
	Vue.component("color-swatch", ColorSwatch); 
	Vue.component("desktop-empty", DesktopEmpty); 
	Vue.component("desktop-file-item", DesktopFileItem); 
	Vue.component("detail-field", DetailField); 
	Vue.component("download-file-preview", DownloadFilePreview); 
	Vue.component("download-folder-preview", DownloadFolderPreview); 
	Vue.component("download-items-preview", DownloadItemsPreview); 
	Vue.component("face", Face); 
	Vue.component("file-drop", FileDrop); 
	Vue.component("file-item", FileItem); 
	Vue.component("file-overlay-item", FileOverlayItem); 
	Vue.component("file-upload-preview-item", FileUploadPreviewItem); 
	Vue.component("folder-upload-preview-item", FolderUploadPreviewItem); 
	Vue.component("image-preloader", ImagePreloader); 
	Vue.component("loader", Loader); 
	Vue.component("loading-screen", LoadingScreen); 
	Vue.component("menu-item", MenuItem); 
	Vue.component("mobile-progressbar", MobileProgressbar); 
	Vue.component("remaining", Remaining); 
	Vue.component("search-field", SearchField); 
	Vue.component("search-filter", SearchFilter); 
	Vue.component("search-tab", SearchTab); 
	Vue.component("snackbar-item", SnackbarItem); 
	Vue.component("sort-option", SortOption); 
	Vue.component("svg-icon", SvgIcon); 
	Vue.component("tag", Tag); 
	Vue.component("tool-tip", ToolTip); 
	Vue.component("tooltip-btn", TooltipBtn); 
	Vue.component("top-option", TopOption); 
	Vue.component("tree-title", TreeTitle); 
	Vue.component("user-menu-item", UserMenuItem); 
	Vue.component("vaccordeon", Vaccordeon); 
	Vue.component("vbutton", Vbutton); 
	Vue.component("vcheck", Vcheck); 
	Vue.component("vcolor", Vcolor); 
	Vue.component("vdropdown", Vdropdown); 
	Vue.component("view-option", ViewOption); 
	Vue.component("vinput", Vinput); 
	Vue.component("vlink", Vlink); 
	Vue.component("vslider", Vslider); 
	Vue.component("vswitch", Vswitch); 
	Vue.component("v-text-editor", VTextEditor); 

};

export default importAllVue;
